<script setup>
// Components
import Button from '@/Components/Button/Button.vue';
import Icon from '@/Components/Icon.vue';

// Icons
import close from '@i/close.svg';
import { ref } from 'vue';

const props = defineProps({
    title: String,
    button_label: String,
    external_url: String,
    intended_url: String,
    page_id: String,
});

const active = ref(true);

const hide = () => {
    active.value = false;
};
</script>

<template>
    <div class="fixed z-50 h-auto p-6 rounded-tl-3xl right-5 bg-primary w-80 bottom-5" v-if="title && active === true">
        <div class="flex items-start justify-between">
            <h2 class="mb-1 text-2xl">{{ title }}</h2>

            <div ref="fixed-cta" @click="hide()" class="flex items-center gap-3 cursor-pointer group">
                <Icon :icon="close" class="mt-2" />
            </div>
        </div>

        <Button
            v-if="button_label && intended_url"
            white
            :is="'a'"
            :href="intended_url"
            :label="button_label"
            :target="page_id === null || page_id === undefined ? true : false"
            class="relative z-30 w-auto mt-8"
        ></Button>
    </div>
</template>
